import GastoIaPage from './gasto-ia.vue';
import RoutesUtils from '../../js/RoutesUtils.js';

/**
 * #815 · Gasto de IA, solo para ADMIN.
 *
 * Manda el menú de Mongo, como en todas las rutas: el lote `fase-ia-gasto-2026-10` de movilidad da
 * de alta `/gasto-ia/` solo para ADMIN, y esa entrada del menú lateral es el único punto de entrada,
 * así que quien no la tiene no la ve. La ruta no cuelga de `/dashboard/` ni de `/agenteia/` a
 * propósito: `RoutesUtils.isInMenu` deja pasar toda ruta que empiece por un link del menú, y esos
 * dos los tienen otros perfiles. Y aunque alguien llegara, el endpoint responde 403 a quien no es
 * ADMIN y la pantalla lo dice.
 */
export const RUTA_GASTO_IA = '/gasto-ia/';
export const ROLES_GASTO_IA = ['ADMIN'];

const routes = [
    {
        path: RUTA_GASTO_IA,
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('gasto-ia', ROLES_GASTO_IA, GastoIaPage)
    }
];

export default routes;
